// extracted by mini-css-extract-plugin
module.exports = {"anotherRestaurant":"style_anotherRestaurant__3oVZq","buttons":"style_buttons__e2XvY"};